"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiInputLabelOverrides = function (_a) {
    var _b;
    var palette = _a.palette, spacing = _a.spacing, breakpoints = _a.breakpoints;
    return ({
        outlined: (_b = {
                margin: 0,
                lineHeight: 1.4,
                transform: "translate(" + spacing(3) + "px, " + spacing(4) + "px) scale(1)"
            },
            _b[breakpoints.up("xl")] = {
                transform: "translate(" + spacing(3) + "px, " + spacing(5) + "px) scale(1)",
            },
            _b["&$shrink"] = {
                transform: "translate(" + spacing(3) + "px, " + spacing(2) + "px) scale(0.875)",
            },
            _b["&$focused, &$error"] = {
                color: palette.text.secondary,
            },
            _b["&$disabled"] = {
                color: palette.divider,
            },
            _b),
    });
};
//# sourceMappingURL=MuiInputLabel.js.map